import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { PopoverDirective } from 'ngx-bootstrap/popover';

@Component({
  selector: 'glm-merged-buttons',
  templateUrl: './merged-buttons.component.html',
  styleUrls: ['./merged-buttons.component.css'],
})
export class MergedButtonsComponent
  implements OnInit, OnChanges, AfterViewInit
{
  constructor() {}

  ngOnInit(): void {}
  ngAfterViewInit() {}
  @Input() title = '';
  @Input() value = '';
  @Input() icon_name = null;
  @Input() sequence = 0;
  @Output() _click = new EventEmitter();
  @Input() id = '';
  @Input() isDropDown = false;
  @Input() isRoundEdges = false;
  @Input() type = 'merged';
  @Input() disabled = false;

  @ViewChild(PopoverDirective) popOverDirective: PopoverDirective;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.title || changes.value) {
      this._click.emit({ id: this.id, value: this.value, label: this.title });
      this.popOverDirective ? this.popOverDirective.toggle() : false;
    }
  }

  btn_click() {
    if (!this.disabled) {
      this._click.emit({ id: this.id, value: this.value, label: this.title });
    }
  }
}
